import { useCallback, useState } from "react";
import { notificacionError } from "@/components/Alerts.js";
import { useAppForm } from "@/hooks/useForm.js";
import { getArticuloByReference, zInputsAddComponente, type iInputsAddComponente, type InfoComponente } from "@/hooks/Api/OrdenesFabricacion.js";


export function FormComponente(props: { readonly data: InfoComponente[], readonly setData: Setter<InfoComponente[]>; }) {
	const [adding, setAdding] = useState(false);
	const form = useAppForm({
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- Se usa para tipar form
		defaultValues: {
			referencia: "",
			cantidadPorUnidad: null,
		} satisfies iInputsAddComponente as iInputsAddComponente,
		validators: {
			onSubmit: zInputsAddComponente,
		},
		onSubmit: async ({ value }) => {
			if (value.cantidadPorUnidad == null || isNaN(value.cantidadPorUnidad) || value.cantidadPorUnidad <= 0) {
				notificacionError("La cantidad debe ser un número válido y mayor que 0.");
				return false;
			}

			const articulo = await getArticuloByReference(value.referencia);
			if (!articulo.exists) {
				notificacionError("La referencia de artículo no es válida o no se ha encontrado.");
				return false;
			}

			if (props.data.some(comp => comp.idComponente == articulo.id)) {
				notificacionError("Este componente ya ha sido agregado.");
				return;
			}
			const infoComponente: InfoComponente = {
				idComponente: articulo.id,
				referencia: articulo.referencia,
				descComponente: articulo.descripcion,
				cantidadPorArticulo: value.cantidadPorUnidad,
				faseUsado: null,
			};


			props.setData((prev) => [...prev, infoComponente]);

			form.reset();
			setAdding(false);
		},
	});
	const onSubmit = useCallback((event: React.SubmitEvent) => {
		event.preventDefault();
		event.stopPropagation();
		void form.handleSubmit();
	}, [form]);


	return (
		<div style={{ borderTop: "1px solid black" }} id="contenedorAddComponente">
			<div style={{ display: adding ? "none" : undefined }}>
				<button style={{ width: "100%", border: "none", padding: "8px 10px" }} type="button" onClick={() => { setAdding(true); }}>
					Añadir Componente
				</button>
			</div>
			<div style={{ display: adding ? undefined : "none" }}>
				<form onSubmit={onSubmit} style={{ display: "flex", justifyContent: "space-between", padding: "8px 10px" }}>
					<form.AppField name="referencia">
						{field => (
							<label style={{ margin: 0, display: "flex", gap: 10, alignItems: "center" }}>
								<span>Referencia </span>
								<field.TextField />
							</label>
						)}
					</form.AppField>

					<form.AppField name="cantidadPorUnidad">
						{field => (
							<label style={{ margin: 0, display: "flex", gap: 10, alignItems: "center" }}>
								<span>Cantidad por unidad fabricada</span>
								<field.NumberField step="any" />
							</label>
						)}
					</form.AppField>

					<button type="submit">+</button>
				</form>
			</div>
		</div>
	);

}
